import { Button, message, Modal, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import { createBot } from "../../../../redux/bot/actions";
import styles from "../../../../styles/Components/bot/bot-configuration/IntegratedExchangesModal.module.css";
import { Link, useNavigate } from "react-router-dom";
import useFetchIntegratedExchanges from "../../../../hooks/api/useFetchIntegratedExchanges";

function IntegratedExchangesModal({ show, onClose, data, goHome }) {
  const {
    exchangeState: { integratedData, integratedDataLoading },
    main: { userData },
    botState: { createBotLoading },
  } = useSelector((state) => state);

  const [selectedExchange, setSelectedExchange] = useState(
    integratedData?.[0]?.id || "",
  );

  const dispatch = useDispatch();

  const activeExchanges = [...integratedData]?.filter(
    (item) => item.status === "Active",
  );

  const closeModal = () => {
    setSelectedExchange("");
    onClose(false);
  };

  const copyCustomBot = async () => {
    if (createBotLoading) return;
    if (!selectedExchange)
      return message.info("Please select an exchange first!");

    await dispatch(
      createBot(
        userData?.["custom:custom_username"],
        userData?.["cognito:username"],
        {
          ...data,
          selected_exchange: selectedExchange,
        },
      ),
    ).then(() => {
      closeModal();
      if (goHome) {
        goHome();
      }
    });
  };

  useFetchIntegratedExchanges();

  return (
    <Modal
      open={show}
      onCancel={closeModal}
      footer={null}
      centered
      closable={!createBotLoading}
      maskClosable={false}
    >
      <h3 className={styles.title}>
        Select the exchange you want to trade from your connected exchanges:
      </h3>
      {integratedDataLoading ? (
        <div className={styles.loader}>
          <Spin />
          <span>Fetching integrated exchanges...</span>
        </div>
      ) : activeExchanges.length > 0 ? (
        <ul className={styles.exchangeList}>
          {activeExchanges.map((exchange) => (
            <li
              key={exchange.id}
              className={`${
                selectedExchange === exchange.id ? styles.selected : ""
              }`}
              onClick={() => setSelectedExchange(exchange.id)}
            >
              <img
                src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/${exchange.id}.svg`}
                alt={exchange.id}
              />
              {exchange.name}
            </li>
          ))}
        </ul>
      ) : (
        <p className={styles.noExchange}>
          No exchange integrated yet.{"  "}
          <Link className={styles.emptyLink} to={"/portfolio"}>
            Integrate now!
          </Link>
        </p>
      )}

      {/*{activeExchanges.length > 0 && (*/}
      {/*  <ul className={styles.exchangeList}>*/}
      {/*    {activeExchanges.map((exchange) => (*/}
      {/*      <li*/}
      {/*        key={exchange.id}*/}
      {/*        className={`${*/}
      {/*          selectedExchange === exchange.id ? styles.selected : ""*/}
      {/*        }`}*/}
      {/*        onClick={() => setSelectedExchange(exchange.id)}*/}
      {/*      >*/}
      {/*        <img*/}
      {/*          src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/${exchange.id}.svg`}*/}
      {/*          alt={exchange.id}*/}
      {/*        />*/}
      {/*        {exchange.name}*/}
      {/*      </li>*/}
      {/*    ))}*/}
      {/*  </ul>*/}
      {/*)}*/}

      {/*{activeExchanges.length === 0 && (*/}
      {/*  <p className={styles.noExchange}>*/}
      {/*    No exchange integrated yet.{"  "}*/}
      {/*    <Link className={styles.emptyLink} to={"/integration"}>*/}
      {/*      Integrate now!*/}
      {/*    </Link>*/}
      {/*  </p>*/}
      {/*)}*/}
      {!integratedDataLoading && (
        <div className={styles.btns}>
          <Button
            loading={createBotLoading && !!selectedExchange}
            type={"primary"}
            onClick={copyCustomBot}
            className={styles.saveBtn}
          >
            Submit
          </Button>
        </div>
      )}
    </Modal>
  );
}

export default IntegratedExchangesModal;
